import React, { useMemo } from "react";
import {
  Autocomplete,
  Checkbox,
  ListItemText,
  MenuItem,
  Popper,
  TextField,
} from "@mui/material";
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";

const MultiLocationAutocomplete = ({
  options = [],
  xValue = [],
  xtabIndex = "",
  xDisabled = false,
  label,
  placeholder,
  setValue
}) => {
  const allOptions = useMemo(
    () => [{ Uid: "select-all", Name1: "Select All" }, ...options],
    [options]
  );

  const isAllSelected =
    xValue?.length > 0 &&
    options?.length > 0 &&
    xValue?.length === options?.length;

  const handleChange = (event, newValue) => {
    
    if (!Array.isArray(newValue)) return;

    const hasSelectAll = newValue.some((item) => item.Uid === "select-all");

    if (hasSelectAll) {
      // If all are selected, uncheck all
      if (isAllSelected) {
        setValue([]);
      } else {
        // Select all
        const allUIDs = options?.map((item) => item.Uid);
        setValue(allUIDs);
      }
    } else {
      const selectedUIDs = newValue.map((item) => item.Uid);
      setValue(selectedUIDs);
    }
  };

  const isSelected = (option) => xValue?.includes(option.Uid);

  return (
    <div
      // className="GCAutocompleteCheckboxFixSize"
      style={{ background: xDisabled ? "#e9ecef" : "transparent" }}
    >
      <Autocomplete
        tabIndex={xDisabled ? "" : xtabIndex}
        disabled={xDisabled}
        multiple
        size="small"
        options={allOptions}
        getOptionLabel={(option) => option?.Name1 || ""}
        value={options?.filter((grp) => xValue?.includes(grp.Uid)) || []}
        isOptionEqualToValue={(option, value) => option.Uid === value.Uid}
        onChange={handleChange}
        disableCloseOnSelect
        PopperComponent={(props) => (
          <Popper
            {...props}
            style={{
              zIndex: 1300,
              width: props.anchorEl ? props.anchorEl.clientWidth : "auto",
            }}
            placement="bottom-start"
          />
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
            sx={{
              fontSize: "12px",
              "& .MuiOutlinedInput-root": {
                maxHeight: "32px",
                overflowY: "auto",
                border: "1px solid #ddd",
                padding: "0px !important",
                minWidth: "0px !important",
              },
              "& .MuiAutocomplete-input": {
                padding: "7.5px 4px 7.5px 5px !important",
              },
            }}
          />
        )}
        renderOption={(props, option, { selected }) => {
          if (option.Uid === "select-all") {
            return (
              <MenuItem
                {...props}
                sx={{
                  height: "31px",
                  minHeight: "31px",
                  padding: "0 8px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  size="small"
                  checked={isAllSelected}
                  indeterminate={
                    xValue?.length > 0 && xValue?.length < options?.length
                  }
                />
                <ListItemText
                  primary="Select All"
                  primaryTypographyProps={{
                    fontSize: "12px",
                    lineHeight: "1.2",
                  }}
                />
              </MenuItem>
            );
          }

          return (
            <MenuItem
              {...props}
              sx={{
                height: "31px",
                minHeight: "31px",
                padding: "0 8px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Checkbox size="small" checked={isSelected(option)} />
              <ListItemText
                primary={option?.Name1}
                primaryTypographyProps={{
                  fontSize: "12px",
                  lineHeight: "1.2",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              />
            </MenuItem>
          );
        }}
      />
    </div>
  );
};

export default MultiLocationAutocomplete;
